import selectTemplate from "./Select.hbs";
import "./select.scss";

const select = {
    init: () => {
        select.renderSelects();
        select.addEventListeners();
    },
    renderSelects: () => {
        const selects = document.querySelectorAll("[js-select]");

        if (selects.length > 0) {
            selects.forEach((select, index) => {
                const selectItem = select as HTMLSelectElement;
                const optionItems: Array<object> = [];
                const isSearchable = select.attributes.getNamedItem("searchable") ? true : false;

                const dataLabels: object = {
                    "titleLabel": select.getAttribute("data-label-title"),
                    "chooseLabel": select.getAttribute("data-label-choose"),
                    "selectedLabel": select.getAttribute("data-label-selected"),
                    "optionLabel": select.getAttribute("data-label-option"),
                    "optionsLabel": select.getAttribute("data-label-options"),
                    "searchLabel": select.getAttribute("data-label-search")
                };

                const selectData = {
                    "id": `select-${index}`,
                    "name": selectItem.name,
                    "multiple": selectItem.multiple,
                    "searchable": isSearchable,
                    "options": optionItems,
                    "labels": dataLabels
                };

                Array.prototype.forEach.call(selectItem.options, function (option) {
                    const val = option.value as string;
                    const txt = option.textContent as string;

                    optionItems.push({ value: val, textValue: txt })
                });

                const selectWrapperNode = document.createElement("div");

                selectWrapperNode.setAttribute("js-select", "");
                selectWrapperNode.setAttribute("name", selectData.name);
                selectWrapperNode.id = selectData.id;
                selectWrapperNode.classList.add("select");
                select.insertAdjacentElement("beforebegin", selectWrapperNode);

                const targetElement = document.getElementById(selectData.id);

                if (targetElement) {
                    targetElement.innerHTML = selectTemplate(selectData);
                    select.remove();
                }
            });
        }
    },
    addEventListeners: () => {
        const selectItems = document.querySelectorAll("[js-select]");
        const toggleSelectButton = document.querySelectorAll("[js-select-toggle]");
        const optionItems = document.querySelectorAll("[js-select-item]");
        const clearFilterButtons = document.querySelectorAll("[js-clear-filter]");
        const searchInput = document.querySelectorAll("[js-select-search]");

        selectItems.forEach((selectItem) => {
            selectItem.addEventListener("click", (e: Event) => {
                const target = e.target as HTMLDivElement;

                if (target) {
                    if (target.classList.contains("expanded")) {
                        select.toggleSelect(target, false);
                    }
                }
            });
        });

        toggleSelectButton.forEach((selectButton) => {
            selectButton.setAttribute("aria-expanded", "false");
            selectButton.addEventListener("click", (e: Event) => {
                e.preventDefault();
                const target = e.target as HTMLButtonElement;

                if (target) {
                    const parent = target.closest("[js-select]") as HTMLDivElement;

                    if (parent) {
                        if (!parent.classList.contains("expanded")) {                         
                            select.toggleSelect(parent, true);
                        }
                        else {                            
                            select.toggleSelect(parent, false);
                        }
                    }
                }
            });
        });

        optionItems.forEach((optionItem) => {
            // Click event
            optionItem.addEventListener("click", (e: Event) => {
                const target = e.target as HTMLLIElement;

                if (target) {
                    select.toggleOptionItem(target);
                }
            });
            // Keydown event
            (optionItem as HTMLElement).addEventListener("keydown", (e: KeyboardEvent) => {
                const target = e.target as HTMLElement;
                if (e.key === " " || e.key === "Enter") {
                    e.preventDefault(); 
                    select.toggleOptionItem(target);
                }
            });
        });

        clearFilterButtons.forEach((clearFilterButton) => {
            clearFilterButton.addEventListener("click", (e: Event) => {
                e.preventDefault();

                const target = e.target as HTMLDivElement;
                const currentSelect = target.closest("[js-select]") as HTMLDivElement;

                if (target) {
                    select.clearOptions(currentSelect);
                }
            });
        });

        if (searchInput.length > 0) {
            searchInput.forEach((input) => {
                input.addEventListener("keyup", (e: Event) => {

                    const target = e.target as HTMLInputElement;
                    const parent = target.closest("[js-select-panel]");
                    const userInputFilter = target.value.toUpperCase();

                    if (parent) {
                        const elements = parent.querySelectorAll("[js-select-item]");

                        if (elements.length > 0) {
                            elements.forEach((element) => {
                                const item = element as HTMLElement;
                                const selectItem = item.querySelector("span");

                                if (selectItem !== null) {
                                    const selectItemProcessed = selectItem.innerText.toUpperCase()

                                    if (selectItemProcessed.indexOf(userInputFilter) > -1) {


                                        item.style.display = "";
                                    } else {
                                        item.style.display = "none";
                                    }
                                }
                            });
                        }
                    }
                });
            })
        }
    },
    toggleSelect: (elem: HTMLElement, expanded: boolean) => {
        const selectButton = elem.querySelector("[js-select-toggle]") as HTMLButtonElement;
        if (expanded) {           
            selectButton.setAttribute("aria-expanded", "true");

            elem.classList.add("expanded");
        }
        else {
            selectButton.setAttribute("aria-expanded", "false");

            elem.classList.remove("expanded");
        }
    },
    toggleOptionItem: (elem: HTMLElement) => {
        const parent = elem.closest("[js-select]") as HTMLDivElement;
        const isMultiSelect = elem.classList.contains("multiple");

        //Multi select
        if (isMultiSelect) {
            const isChecked = elem.classList.toggle("checked");
            elem.setAttribute("aria-checked", isChecked.toString());
        }
        //Single select
        else {
            if (!elem.classList.contains("checked")) {
                const previousSelectedItem = parent.querySelector(".checked");

                if (previousSelectedItem) {
                    previousSelectedItem.classList.remove("checked");
                    previousSelectedItem.setAttribute("aria-checked", "false");
                }

                elem.classList.add("checked");
                elem.setAttribute("aria-checked", "true");
                select.toggleSelect(parent, false);
            }
        }

        //Loop through selected items to get checked amount
        if (parent) {
            const items = parent.querySelectorAll("[js-select-item].checked");

            if (isMultiSelect) {
                select.setLabels(parent, items.length, true);
            }
            else {
                select.setLabels(parent, 1, false);
            }
        }

    },
    clearOptions: (currentSelect: HTMLDivElement) => {
        const checkedItems = currentSelect.querySelectorAll("[js-select-item].checked");

        if (checkedItems.length > 0) {
            checkedItems.forEach((checkedItem) => {
                checkedItem.classList.remove("checked");
                select.setLabels(currentSelect, 0, true);
                select.toggleSelect(currentSelect, false);
            });
        }
    },
    setLabels: (currentSelect: HTMLElement, amount: number, isMultiSelect: boolean) => {
        const clearFilterButton = currentSelect.querySelector("[js-clear-filter]") as HTMLElement;
        const labelContainer = currentSelect.querySelector("[js-select-title]") as HTMLElement;
        const selectTitleLabel = labelContainer.getAttribute("data-label-title");
        const selectSelectedLabel = labelContainer.getAttribute("data-label-selected");
        const selectOptionLabel = labelContainer.getAttribute("data-label-option");
        const selectOptionsLabel = labelContainer.getAttribute("data-label-options");

        if (isMultiSelect) {
            switch (amount) {
                case 0:
                    if (selectTitleLabel) {
                        labelContainer.innerText = selectTitleLabel;
                    }
                    else {
                        labelContainer.innerText = "Select option";
                    }

                    clearFilterButton.style.display = "none";
                    break;
                case 1:
                    if (selectOptionLabel && selectSelectedLabel) {
                        labelContainer.innerText = amount + " " + selectOptionLabel + " " + selectSelectedLabel;
                    }
                    else {
                        labelContainer.innerText = amount + " option selected";
                    }

                    clearFilterButton.style.display = "flex";
                    break;
                default:
                    if (selectOptionsLabel && selectSelectedLabel) {
                        labelContainer.innerText = amount + " " + selectOptionsLabel + " " + selectSelectedLabel;
                    }
                    else {
                        labelContainer.innerText = amount + " options selected";
                    }

                    clearFilterButton.style.display = "flex";
            }
        }
        else {
            const selectedItem = currentSelect.querySelector(".checked span");

            switch (amount) {
                case 0:
                    if (selectTitleLabel) {
                        labelContainer.innerText = selectTitleLabel;
                    }
                    else {
                        labelContainer.innerText = "Select option";
                    }

                    clearFilterButton.style.display = "none";
                    break;
                default:
                    if (selectedItem) {
                        const selectedTitle = selectedItem.textContent;

                        if (selectedTitle) {
                            labelContainer.innerText = selectedTitle;
                        }
                    }

                    clearFilterButton.style.display = "flex";
            }
        }
    }
}

export { select }